import React, { useState } from "react";
import peliculas from "../db.json";
import Tarjeta from "../components/Tarjeta";
import estilo from "../styles/Inicio.module.css";
import Titulos from "../components/Titulos";
import Recomendadas from "../components/Recomendadas";
import MetaDecorator from "../utils/MetaDecorator";
import Paginacion from "../components/Paginacion";

function Series() {
  const series = peliculas
    .map(({ ...capitulos }) => ({ ...capitulos }))
    .filter((e) => e.tipo === "serie");
  //
  const [elementoPagina, setElementoPagina] = useState(1);
  const [elementosPorPagina] = useState(12);
  const ultimoIndice = elementoPagina * elementosPorPagina;
  const primerIndice = ultimoIndice - elementosPorPagina;
  //
  const elementosSalidaSeries = series.slice(primerIndice, ultimoIndice);
  const paginacion = (numeroPagina) => setElementoPagina(numeroPagina);
  return (
    <div className={estilo.peliculas}>
      <MetaDecorator
        titulo={"RepelisPlus"}
        subtitulo={"RepelisPlus"}
        descripcion={
          "Las mejores peliculas y series las encuentras en RepelisPlus, peliculas de estreno en alta calidad gratis."
        }
      />
      <div className={estilo.linea}></div>
      <Titulos titulo="Series" tipo="series"></Titulos>
      <div className={estilo.grid_peliculas}>
        {elementosSalidaSeries.map((e) => (
          <Tarjeta key={e.id} pelicula={e}></Tarjeta>
        ))}
      </div>

      <div>
        <Paginacion
          elementosPorPagina={elementosPorPagina}
          elementosTotales={series.length}
          paginacion={paginacion}
          pag="pag"
        />
      </div>
      <div className={estilo.linea}></div>
      <Recomendadas></Recomendadas>
      <br></br>
    </div>
  );
}

export default Series;
